export class ValidationConstants {
  static readonly npiRegex = /^\d{10}$/;
  static readonly taxIdRegex = /^\d{9}$/;
  static readonly isoDateRegex =
    /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;
  static readonly timeRegex = /^(?:[01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
}
